// extracted by mini-css-extract-plugin
module.exports = {"button":"_2787e5dfdf--button--DaLzK","badge":"_2787e5dfdf--badge--tV8g0"};